/**
 * Hand-off from the founding gate to the world map: the colony a player has
 * JUST founded gets a one-time "this is your first home colony" callout on
 * the map. Persisted (best effort) so a reload before dismissing still shows
 * it; kept in memory too, for when storage is unavailable.
 */

const KEY = 'dic:homeNoticePending';
let pendingInMemory: string | null = null;

export function markHomeNoticePending(colonyId: string): void {
  pendingInMemory = colonyId;
  try {
    localStorage.setItem(KEY, colonyId);
  } catch {
    // Private mode / blocked storage — the in-memory copy still covers this session.
  }
}

export function isHomeNoticePending(colonyId: string | null): boolean {
  if (!colonyId) return false;
  if (pendingInMemory === colonyId) return true;
  try {
    return localStorage.getItem(KEY) === colonyId;
  } catch {
    return false;
  }
}

export function dismissHomeNotice(): void {
  pendingInMemory = null;
  try {
    localStorage.removeItem(KEY);
  } catch {
    // nothing to clean up
  }
}
